import React, { useContext, useEffect } from 'react'; 
import globalStyles from './../../../assets/styles/global.module.scss'
import headerStyles from '../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'
import { Divider, Grid, useMediaQuery } from '@mui/material';
import GlobalPageHeaderText from '../../utility/globalPageHeaderText';
import GlobalButton from '../../utility/globalButton/button';
import AddIcon from '@mui/icons-material/Add';
import { Outlet } from 'react-router-dom';
import { WorkflowContext, WorkflowContextPayload } from '../../../context/workflowContext';
import GlobalPopUp from '../../utility/globalPopUp';
import CreateWorkflowPopup from './createWorkflowPopup';
import { initialCreateNewFlowObject} from './workflowConstants';
import IntegrateBusinessAccountPopup from '../whatsappCampaign/integrateBusinessAccountPopup';
import WorkflowHeaderText from './workflowHeaderText';
import WorkflowActionBlock from './workflowActionBlock';
import styles from '../../../assets/styles/componentStyles/customApiStyles/customApiStyle.module.scss'
import QrCodePopup from '../../utility/qrCodePopup';
import { CHATBOT_CHANNEL_NAME } from '../../../pages/ruleBasedInbox/channelConstants';

const WorkflowGlobal = () => {

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }

    const { flagNewWorkflowPopup, setFlagNewWorkflowPopup, setCreateNewWorkflowPayload, flagIntegrateBusinessAccountPopup, 
        setFlagIntegrateBusinessAccountPopup, flagShowQRCodePopup, setFlagShowQRCodePopup, setPhoneNumberQR, phoneNumberQR, setConditionGroup, conditionGroup, getWorkFlowIntergrationChannels, getChatbotTypes, qrChannelName, setQrChannelName } = useContext(WorkflowContext) as WorkflowContextPayload

    useEffect(() => {
        (async () => {
            // setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
            await getWorkFlowIntergrationChannels()
            await getChatbotTypes()
            // setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
        })()
    }, []);

    const getActionBlock = () => {
        const pathname = window.location.pathname?.toLowerCase(); 
        switch(pathname){
            case "/workflow": 
                return (
                    <Grid item>
                        <GlobalButton
                            buttonText={"New Chatbot"}
                            className='primaryButtonStyle'
                            startIcon={<AddIcon />}
                            sx={{ width: "170px" }}
                            onClick={() => { setFlagNewWorkflowPopup(true) }}
                        />
                    </Grid>
                );
            case "/workflow/staticworkflowdetails": 
                return (
                    // <Grid item>
                    //     <Grid container gap="25px" alignItems={"center"}>
                    //         <Grid item className={styles.savingVariable}>
                    //             {
                    //                 isCurrentViewVersionPublished(currentActiveStaticWorkflow) ?
                    //                     "View Mode"
                    //                     :
                    //                     <>
                    //                         {saveState === "saving" && "Saving..."}
                    //                         {saveState === "saved" && (
                    //                             <Grid container alignItems={"center"} gap="6px">
                    //                                 <Grid item className={globalStyles.displayFlex}>
                    //                                     <CheckIcon />
                    //                                 </Grid>
                    //                                 <Grid item>Saved</Grid>
                    //                             </Grid>
                    //                         )}
                    //                     </>
                    //             }
                    //         </Grid>

                    //         <Grid item>
                    //             <Autocomplete
                    //                 sx={{ minWidth: "170px" }}
                    //                 className={globalStyles.autocompleteParaphrasing}
                    //                 value={getVersionValue()}
                    //                 options={['Draft Version', 'Published Version']}
                    //                 onChange={(e, value) => onChangeOfVersion(value)}
                    //                 renderInput={(params) => <TextField {...params} placeholder='Select Version...' />}
                    //                 disableClearable
                    //             />
                    //         </Grid>

                    //         <Grid item>
                    //             <GlobalButton
                    //                 buttonText={"Go Live"}
                    //                 className='primaryButtonStyle'
                    //                 sx={{ width: "120px", padding: "6px 20px" }}
                    //                 onClick={() => onClickOfPublishBtn()}
                    //                 disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow) || checkDisablePublishButton()}
                    //             />
                    //         </Grid> 

                    //         {isCurrentChatbotPublishedorPaused(currentActiveStaticWorkflow) && 
                    //             <Grid item>
                    //                 <img 
                    //                     alt="qr_image" 
                    //                     src={QRimage} 
                    //                     height={"24"} 
                    //                     width={"24"} 
                    //                     className={`${globalStyles.clickable} ${globalStyles.displayFlexStyle}`} 
                    //                     onClick={(e) => {
                    //                         e.stopPropagation();
                    //                         const conditionGroupOfChatbot =  currentActiveStaticWorkflow?.chatbot_version_info?.find((version) => version?.chatbot_version_status_name?.toLowerCase() == "published")?.chatbot_step_deployment_trigger_data?.[0]?.condition_group ?? null;
                    //                         onClickOfQRCode(currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0]?.meta_integration_whatsapp_phone_number_data?.[0]?.display_phone_number ?? "", conditionGroupOfChatbot, setFlagShowQRCodePopup, setPhoneNumberQR, setConditionGroup);
                    //                     }} 
                    //                 />
                    //             </Grid>
                    //         }

                    //         <Grid item>
                    //             <MoreVertIcon
                    //                 className={`${globalStyles.clickable}`}
                    //                 onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) => handleMenuOpen(e)}
                    //             />
                    //              <Menu
                    //                 anchorEl={anchorEl}
                    //                 keepMounted
                    //                 open={Boolean(anchorEl)}
                    //                 onClose={handleMenuClose}
                    //             >
                    //                 {actionMenuItemForWorkflow.map((item, index) => {
                    //                     return (
                    //                         <MenuItem
                    //                             className={globalStyles.menuItemStyle}
                    //                             key={index}
                    //                             sx={{ fontSize: "14px", fontWeight: "500" }}
                    //                             onClick={(e) => { e.stopPropagation(); handleMenuClose(); item.action() }}
                    //                         >
                    //                             <span>
                    //                                 {item.label}
                    //                             </span>
                    //                         </MenuItem>
                    //                     );
                    //                 })}
                    //             </Menu>
                    //         </Grid>
                    //     </Grid>
                    // </Grid> 
                    <WorkflowActionBlock />
                );
            default: 
                return <></>;
        }
    }

    const getMainHeaderText = () => {
        const pathname = window.location.pathname?.toLowerCase(); 
        switch(pathname){
            case "/workflow": 
                return "Rule-Based Chatbot";
            case "/workflow/staticworkflowdetails": 
                return <WorkflowHeaderText />;
            default: 
                return "Rule-Based Chatbot";
        }
    }

    useEffect(() => {
        return () => {
            if(flagNewWorkflowPopup){
                setFlagNewWorkflowPopup(false);
                setCreateNewWorkflowPayload(initialCreateNewFlowObject);
            }
        }
    }, [flagNewWorkflowPopup]);

    return (
        <>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${headerStyles.templateWrapper}`}>
                <Grid container sx={{ padding: { xs: "5px 0px", sm: "18px 0px 0px" } }} direction={"column"} flexWrap={"nowrap"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container sx={{ alignItems: "center" }} direction={"column"}>
                            <Grid item className={`${globalStyles.fullwidth} ${globalStyles.headerTextContainerStyle}`}>
                                <GlobalPageHeaderText
                                    // mainHeadText={"Workflow"} 
                                    mainHeadText={getMainHeaderText()}
                                    flagMainTextOnly
                                    actionBlock={
                                        !(breakPoints.smallScreen) &&
                                        <Grid container gap={"12px"} justifyContent={(breakPoints.flagTabletScreen) ? "start" : "end"} flexWrap={"nowrap"}>
                                            {/* {window.location.pathname == "/workflow" &&
                                                <Grid item>
                                                    <GlobalButton
                                                        buttonText={"New Workflow"}
                                                        className='primaryButtonStyle'
                                                        startIcon={<AddIcon />}
                                                        sx={{ width: "170px" }}
                                                        onClick={() => { setFlagNewWorkflowPopup(true) }}
                                                    />
                                                </Grid>
                                            } */}
                                            {getActionBlock()}
                                        </Grid>
                                    }
                                />
                                {!(breakPoints.smallScreen) && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${headerStyles.dividerStyle} ${styles.customAPIPageDivider}`} />}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Outlet />
                </Grid> 

                {flagIntegrateBusinessAccountPopup && 
                    <GlobalPopUp
                        open={flagIntegrateBusinessAccountPopup}
                        onClose={() => { setFlagIntegrateBusinessAccountPopup(false); }}
                        handleClose={() => { setFlagIntegrateBusinessAccountPopup(false); }}
                        flagShowCloseIcon={true}
                        paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "400px"}
                        paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "500px"}
                        borderRadius='10px'
                        titlePadding='0px'
                        overflow="hidden"
                    >
                        <IntegrateBusinessAccountPopup
                            title="To use the Rule-Based Chatbot, please connect your WhatsApp Business Account with us first."
                        />
                    </GlobalPopUp>
                }

                {flagNewWorkflowPopup &&
                    <GlobalPopUp
                        open={flagNewWorkflowPopup}
                        onClose={() => { setFlagNewWorkflowPopup(false); setCreateNewWorkflowPayload(initialCreateNewFlowObject) }}
                        // title={}
                        flagBackdrop
                        paperMinWidth={breakPoints.smallScreen || breakPoints.flagTabletScreen ? "310px" : "600px"}
                        paperMaxwidth={breakPoints.smallScreen || breakPoints.flagTabletScreen ? "610px" : "650px"}
                        flagShowCloseIcon={true}
                        handleClose={() => { setFlagNewWorkflowPopup(false); setCreateNewWorkflowPayload(initialCreateNewFlowObject) }}
                        overflow="hidden"
                        titlePadding='0px'
                    >
                        <CreateWorkflowPopup />
                    </GlobalPopUp>
                } 

                {flagShowQRCodePopup && 
                    <GlobalPopUp
                        open={flagShowQRCodePopup}
                        onClose={() => { setFlagShowQRCodePopup(false); setPhoneNumberQR(""); setConditionGroup(null); setQrChannelName(CHATBOT_CHANNEL_NAME.WHATSAPP); }}
                        handleClose={() => { setFlagShowQRCodePopup(false); setPhoneNumberQR(""); setConditionGroup(null); setQrChannelName(CHATBOT_CHANNEL_NAME.WHATSAPP); }}
                        flagShowCloseIcon={true}
                        paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "400px"}
                        paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "500px"}
                        borderRadius='10px'
                        titlePadding='0px'
                        overflow="hidden"
                    >
                        <QrCodePopup 
                            flagShowTriggerKeyword
                            phoneNumberQR={phoneNumberQR} 
                            conditionGroup={conditionGroup}
                            channelName={qrChannelName}
                        />
                    </GlobalPopUp>
                } 
            </Grid>
        </>
    )
}

export default WorkflowGlobal
